module.exports = __webpack_public_path__ + "static/media/30OIOS9.dcd34c10.jpg";